import { render } from "./fxxg.vue?vue&type=template&id=1ed174ca&scoped=true&ts=true"
import script from "./fxxg.vue?vue&type=script&lang=ts"
export * from "./fxxg.vue?vue&type=script&lang=ts"

import "./fxxg.vue?vue&type=style&index=0&id=1ed174ca&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed174ca"]])

export default __exports__